export const BUILD_VERSION = '1790876280';
